import {useCallback, useEffect, useRef, useState} from "react";
import {DiamondSizeSliderType} from "../../types";

const useDiamondSizeSlider = ({marks,fIndex,allValue,handleAllOptions,shapeKey,isStartWithSetting,isReset} :DiamondSizeSliderType) => {
    const [value, setValue] = useState<[number]>([+Object.keys(marks)[fIndex]]);
    const [isFocus,setIsFocus] = useState<boolean>(false);
    useEffect(() => {
      setValue([+Object.keys(marks)[fIndex]])
    }, [+Object.keys(marks)[fIndex]]);
    const handlePassChangedValue = useCallback((val:number|number[]):void=>{
        if (Array.isArray(val)) {
            const markVal = Object.entries(marks).find(([key, v]) => key.toString() === val[0].toString());
            if (markVal) {
                const shapeValue = allValue.find(v => v.Name === markVal[1]);
                if(shapeValue){
                    if(isStartWithSetting){
                        //@ts-ignore
                        handleAllOptions(shapeValue.Code, shapeKey)
                    }else {
                        //@ts-ignore
                        handleAllOptions(shapeKey, shapeValue)
                    }
                }
            }
        }
    },[marks,handleAllOptions,allValue,isStartWithSetting,shapeKey])

    const handleChange = useCallback((val: number | number[]): void => {
        if (Array.isArray(val)) {
            setValue(val as [number]);

            if(!isFocus){
                handlePassChangedValue(val);
            }
        }
    }, [setValue,marks,allValue,handleAllOptions,shapeKey,isStartWithSetting,isFocus]);

    const handleLabelChangeComplete = useCallback((val: number | number[]) => {
        if (Array.isArray(val)) {
           /* const fromVal = Object.keys(marks)
                .sort((a, b) => (b > a ? -1 : 1))
                .indexOf(val[0].toString());*/
            handlePassChangedValue(val);
        }

    }, [marks]);
    useEffect(()=>{
        if(isReset){
            setValue([+Object.keys(marks)[fIndex]]);
        }
    },[isReset])

    return {
        value,
        handleChange,
        handleLabelChangeComplete,
        setIsFocus
    }
}
export default useDiamondSizeSlider;
